import PropTypes from 'prop-types';

export const defaultIsScrollableContent = true;
export const defaultSidebarComponent = 'nav';
const defaultIsStickyHeader = true;

export const defaultContentOptions = {
  isScrollable: defaultIsScrollableContent,
};
export const defaultHeaderOptions = {
  isSticky: defaultIsStickyHeader,
};
export const defaultSidebarOptions = {
  component: defaultSidebarComponent,
};

const sharedOptionsPropTypes = {
  disablePaddings: PropTypes.bool,
  customStyles: PropTypes.object,
  className: PropTypes.string,
  props: PropTypes.object,
};

export const ContentLayoutPropTypes = {
  content: PropTypes.node,
  header: PropTypes.node,
  sidebar: PropTypes.node,
  sidebarOptions: PropTypes.shape(
    Object.create(sharedOptionsPropTypes, {
      component: { value: PropTypes.oneOf(['nav', 'aside']) },
    }),
  ),
  headerOptions: PropTypes.shape(
    Object.create(sharedOptionsPropTypes, {
      isSticky: { value: PropTypes.bool },
    }),
  ),
  contentOptions: PropTypes.shape(
    Object.create(sharedOptionsPropTypes, {
      isScrollable: { value: PropTypes.bool },
    }),
  ),
  helmetProps: PropTypes.shape({
    title: PropTypes.string,
    defaultTitle: PropTypes.string,
    titleTemplate: PropTypes.string,
  }),
};
